import { useCallback, useState } from "react";

const STORAGE_KEY = "recentSearches";
const MAX_ITEMS = 8;

const readFromStorage = (): string[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
};

const writeToStorage = (items: string[]) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch {
    // ignore
  }
};

export const useRecentSearches = () => {
  const [items, setItems] = useState<string[]>(readFromStorage);

  const add = useCallback((query: string) => {
    const trimmed = query.trim();
    if (!trimmed) return;
    setItems((prev) => {
      const filtered = prev.filter(
        (q) => q.toLowerCase() !== trimmed.toLowerCase()
      );
      const next = [trimmed, ...filtered].slice(0, MAX_ITEMS);
      writeToStorage(next);
      return next;
    });
  }, []);

  const remove = useCallback((query: string) => {
    setItems((prev) => {
      const next = prev.filter((q) => q !== query);
      writeToStorage(next);
      return next;
    });
  }, []);

  return { items, add, remove };
};
